import CollectionItem from './CollectionItem.container'

export default CollectionItem
